//#region imports
import React from "react";

// boostrap
import Container from 'react-bootstrap/Container';
import { Row, Col, Form, Card, Button, Image } from 'react-bootstrap';

// font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faLinkedin, faTwitter, faAppStoreIos, faAndroid } from '@fortawesome/free-brands-svg-icons';

// images
import bgNo from "_assets/images/PRM-Logo-PNG/logo-removebg-preview.png";

// styles
import './footer.css';
//#endregion


const Footer = () => {

  return (
    <div className="px-4 py-5 bg-light overflow-hidden">
      <hr></hr>
      {/* Social Icons */}
      <div className="parent-footer">
        <div className="" id="brand-social">
          <div className="brand-social-label">
            <img className="" src={bgNo} style={{ objectFit: 'contain', width: 100 }} />
          </div>
          <div className="brand-social-icons">
            <a href="https://www.facebook.com/prmassist" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} size="2x" color="grey" />
            </a>
            <a href="https://www.linkedin.com/company/prmassist/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} size="2x" color="grey" />
            </a>

            <a href="https://twitter.com/PrmAssist" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} size="2x" color="grey" />
            </a>

            <a href="https://www.instagram.com/prm_assist" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} size="2x" color="grey" />
            </a>
          </div>
        </div>

        {/* Request a Demo */}
        <div className="mt-4">
          <a href="mailto:demorequest@prmassist.com?subject=Demo%20Request" style={{ textDecoration: 'none' }}>
            <Button
              style={{
                backgroundColor: '#3b7ab4',
                borderColor: '#3b7ab4',
                borderRadius: '25px',
                paddingLeft: '2em',
                paddingRight: '2em',
              }}
            >
              Request a Demo
            </Button>
          </a>
        </div>

        {/* Privacy & navigation links */}
        <div className="privacy-div mt-5">
          <a
            className="text-decoration-none fw-bold"
            style={{ color: '#6c757d', opacity: 0.8 }}
            href="https://connect.prmassist.com/"
          >
            PRM Connect
          </a>
          <a
            className="text-decoration-none fw-bold"
            style={{ color: '#6c757d', opacity: 0.8 }}
            href="https://prmassist.com/contact"
          >
            Contact
          </a>
          <a className="text-decoration-none fw-bold" href="https://www.prmassist.com/website-privacy">
            Privacy Policy
          </a>
        </div>
      </div>

    </div>

  )
}

export default Footer;